<template>
  <div class="review">
    <v-container grid-list-md fluid pa-0>
      <v-layout row wrap>
        <!-- <v-flex md3 justify-center align-center>
          <div class="star-rating">
            <v-rating
              v-model="review.star_rating"
              readonly
              dense
              color="#f9a825"
              background-color="#f9a825"
            ></v-rating>
          </div>
          <div class="star-text">({{ review.star_rating }} stars)</div>
        </v-flex>-->
        <v-flex md12>
          <div class="details">
            <div class="star-rating">
              <v-rating
                v-model="review.star_rating"
                readonly
                dense
                color="#f9a825"
                background-color="#f9a825"
              ></v-rating>
            </div>
            <div
              class="action view-on-amazon"
              v-if="review.assignment.status === 'Approved'"
              @click="copyLink"
            >
              Copy Link
            </div>
          </div>
          <div class="author-and-date">
            <div class="author">{{ review.author_name }}</div>
            <div class="date" v-if="review.assignment.approved_at">
              {{ review.assignment.approved_at | date }}
            </div>
          </div>
          <status-messages
            v-if="review.assignment.status_messages"
            :assignment="review.assignment"
          ></status-messages>
          <div class="content" v-if="review.assignment.status === 'ActionRequested'">
            <p v-if="review.assignment.requested_edit">Our staff has requested that the review be edited on Amazon based on the details from your report.</p>
            <p v-else-if="review.assignment.requested_delete">Our staff has requested that the review be deleted from Amazon following your report.</p>
            <p v-else>This review has been published on Amazon and you have reported an issue.</p>
            <further-actions
              :review="review"
              :assignment="review.assignment"
              v-if="hasFurtherActions()"
            ></further-actions>
          </div>
          <div class="content" v-else-if="review.assignment.status === 'ActionApproved'">
            <p v-if="review.assignment.requested_edit">This review has been edited on Amazon based on the details from your report.</p>
            <p v-else-if="review.assignment.requested_delete">This review has been deleted from Amazon following your report.</p>
            <p v-else-if="reviewDissapeared">This review had been published on Amazon but has dissapeared.</p>
            <p v-else>This review has been published on Amazon!</p>
            <further-actions
              :review="review"
              :assignment="review.assignment"
              v-if="hasFurtherActions()"
            ></further-actions>
          </div>
          <div class="content" v-else-if="review.assignment.status === 'Approved'">
            <p v-if="wasApprovedCancelled"> This review was previously cancelled, but has since been approved by our staff.
              <span v-if="review.assignment.is_verified">Your snaps were refunded when the assignment was cancelled, so no snaps have been taken for this review.</span>
              <span v-else>Even though your book was returned to the Library to find a new reader, no additional snaps were taken for this review.</span>
            </p>
            <p v-else>This review has been published on Amazon and approved by our staff!</p>
            <p>
              Click the blue "Copy Link" button to view the published review on
              your book listing.
            </p>
            <further-actions
              :review="review"
              :assignment="review.assignment"
              v-if="hasFurtherActions()"
            ></further-actions>
          </div>
          <div class="pending-approval-content" v-else>
            This review has been turned in and is waiting approval by Amazon.
            <br />
            <br />Once it has been approved and is live on Amazon, we'll add the
            review content and link here.
          </div>

          <assignment-footer
            :assignment="review.assignment"
          ></assignment-footer>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import StatusMessages from "./StatusMessages";
import AssignmentFooter from "./AssignmentFooter";
import FurtherActions from "./FurtherActions.vue";

export default {
  name: "Review",
  components: {
    "status-messages": StatusMessages,
    AssignmentFooter,
    "further-actions": FurtherActions,
  },
  props: ["review"],

  data: function () {
    return {};
  },
  created() {
    // console.log("review", this.review);
  },
  computed: {
    wasApprovedCancelled() {
      if (this.review.assignment.status_messages) {
        return this.review.assignment.status_messages['approve-after-cancel'];
      }
      return false
    },
    reviewDissapeared() {
      if (!this.review.assignment.review_issue || !this.review.assignment.review_issue.issue) {
        return false;
      }
      return this.review.assignment.review_issue.issue.label === 'Disappeared'
    }
  },
  methods: {
    hasFurtherActions() {

      //disable further actions buttons:
      return true;

      const date = new Date(
        this.review.assignment.approved_at.replace(/-/g, "/")
      );
      const time = date.getTime();

      const threshold = new Date("2021-09-01");
      const thresholdTime = threshold.getTime();
      // console.log("hasFurtherActions", time, thresholdTime);
      return time > thresholdTime;
    },
    copyLink() {
      console.log("copyLink");
      this.$toasted.show(
        "The link has been copied! Paste it into your browser to visit the Amazon page, or share it with others!",
        {
          icon: "link",
          position: "bottom-center",
          duration: 4000,
        }
      );

      copyToClipboard(this.review.url);
    },
  },
};

function copyToClipboard(text) {
  if (window.clipboardData && window.clipboardData.setData) {
    // IE specific code path to prevent textarea being shown while dialog is visible.
    return clipboardData.setData("Text", text);
  } else if (
    document.queryCommandSupported &&
    document.queryCommandSupported("copy")
  ) {
    var textarea = document.createElement("textarea");
    textarea.textContent = text;
    textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in MS Edge.
    document.body.appendChild(textarea);
    textarea.select();
    try {
      return document.execCommand("copy"); // Security exception may be thrown by some browsers.
    } catch (ex) {
      console.warn("Copy to clipboard failed.", ex);
      return false;
    } finally {
      document.body.removeChild(textarea);
    }
  }
}
</script>

<style lang="scss" scoped>
.review {
  background: #fff;
  box-shadow: 0px 1px 0.5rem rgba(116, 75, 75, 0.25);
  margin: 0 0 8px 0;
  padding: 8px 30px 16px 30px;
  border-radius: 8px;
  font-family: "Source Sans Pro";
}
.star-rating {
  padding-top: 15px;
  text-align: left;
  flex-grow: 1;
}

.star-text {
  text-align: center;
  font-size: 12pt;
  font-family: "Source Sans Pro";
}

.details {
  display: flex;
  padding: 6px 0;
}

.author-and-date {
  display: flex;
}

.author {
  text-align: left;
  flex-grow: 0;
  padding-top: 14px;
  padding-left: 0.25em;
  color: $color-blue;
  font-size: 15pt;
  font-weight: 700;
  font-family: "Source Sans Pro";
}

.date {
  text-align: left;
  flex-grow: 1;
  padding-top: 14px;
  padding-left: 1em;
  color: lighten($color-blue, 0%);
  font-size: 15pt;
  font-weight: 500;
  font-family: "Source Sans Pro";
}

.content,
.pending-approval-content {
  padding: 1em 0.3em;
  font-size: 13pt;
  font-family: "Source Sans Pro";
  line-height: 1.5em;
}

.action {
  float: left;
  min-width: 148px;
  border-radius: 4px;
  padding: 8px 16px 9px 16px;
  font-size: 11pt;
  font-weight: 700;
  text-transform: none;
  font-family: "Source Sans Pro";
  text-transform: uppercase;
  text-align: center;
  letter-spacing: 1px;
}

.view-on-amazon {
  margin-top: 9px;
  background: #daedff;
  color: #2196f3;
}
</style>
